module.exports = __webpack_public_path__ + "img/the-telegraph.5a9a5d6a.svg";